export default __webpack_public_path__ + "static/guest-verification-resource-img-1-5e9c6d37e244422ef4c9b5225765a9a3.png";